import type { WebFeaturesOutputDto } from '@bldsoft/cappie/api/ovp'
import { createEffect } from 'effector'
import { client } from '../../client'
import { type HeaderFxParameter } from '../../index.h'
import { callInitFromParams, throwOvpTransportError } from '../../lib'

export type Features = WebFeaturesOutputDto

export interface AnotherPlatformObj {
  /** Backend platform key (ios, android, fireTv, …) */
  platform: string
  appId: string
  url: string
}

export const getFx = createEffect<HeaderFxParameter, Features | null>(
  async (params) => {
    const result = await client.get.api.web.features(callInitFromParams(params))

    if (result.kind === 'success') {
      return (result.payload ?? {}) as Features
    }

    throwOvpTransportError(result)
  }
)
